/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

var LOAD_MORE = "load-more";
var LOADING = "loading";

export { LOADING, LOAD_MORE };
//# sourceMappingURL=const.js.map
